TYPE_STATIC_GRAY_DARK